import { Icon } from "@iconify/react";
import React, { useState } from "react";
import { Form } from "react-bootstrap";

export default function InputField({
  icon,
  type,
  style,
  errors,
  touched,
  ...other

}) {
  // state
  const [showPassword, setShowPassword] = useState(false);

//   console.log("errors,", errors);
//   console.log("touched",touched)
  return (
    <div>
      <div style={{ position: "relative" }}>
        <div
          style={{
            top: 0,
            left: 10,
            position: "absolute",
            height: "100%",
            display: "flex",
            alignItems: "center",
            color: "#6C757D",
          }}
        >
          {icon}
        </div>
        <div
          style={{
            top: 0,
            right: 10,
            position: "absolute",
            height: "100%",
            display: type === "password" ? "flex" : "none",
            alignItems: "center",
            color: "#6C757D",
            cursor: "pointer",
          }}
          onClick={() => setShowPassword((prev) => !prev)}
        >
          <Icon
            icon={!showPassword ? "uil:eye-slash" : "uil:eye"}
            style={{ width: 24, height: 24 }}
          />
        </div>
        <Form.Control
          style={{ paddingLeft: 40, ...style }}
          isInvalid={errors && touched}
          {...other}
          type={(type === "password") & showPassword ? "text" : type}
        />
      </div>
      {/*  */}
      <div
        style={{
          display: errors && touched ? "flex" : "none",
          color: "#FF0000",
          gap: 5,
          alignItems: "center",
          marginTop: 1
        }}
      >
        <Icon
          icon="material-symbols:info-outline"
          style={{ width: 18, height: 18 }}
        />
        <span>
          {errors ? errors : "ກະລຸນາປ້ອນຂໍ້ມູນນີ້"}
        </span>
      </div>
    </div>
  );
}
